export default __webpack_public_path__ + "static/slide2-b4397b1d0aa7f0d5bb56f40b59a7f7c0.jpg";